import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Navigation = ({ scrollY }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      const el = document.getElementById(id);
      if (el) {
        const yOffset = -120;
        const y =
          el.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
    setMenuOpen(false);
  };
  const openWhatsApp = () => {
    const phoneNumber = "919030618006"; // replace with your WhatsApp number (country code + number)
    const message = "Hi, I would like to book a shoot with TagTeam Studios.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
    setMenuOpen(false);
  };

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Gallery", path: "/gallery" },
    { label: "Films", scroll: "films" },
    { label: "About", scroll: "about" },
    { label: "Contact", scroll: "contact" },
  ];

  return (
    <>
      {/* NAVBAR */}
      <nav
        className={`fixed top-0 w-full z-50 transition-all duration-700 ${scrollY > 100
            ? "bg-neutral-950/80 backdrop-blur-l py-1"
            : "bg-transparent py-2"
          }`}
      >
        <div className="max-w-[1800px] mx-auto px-6 lg:px-12 flex justify-between items-center">

          {/* LOGO */}
          <Link
            to="/"
            className="cursor-hover relative z-10 flex items-center"
          >
            <img
              src="/assets/transparent_logo.png"
              alt="TagTeam Studios Logo"
              className="h-14 md:h-20 object-contain"
            />
          </Link>

          {/* DESKTOP NAV */}
          <div className="hidden md:flex items-center gap-12">
            {navItems.map((item) =>
              item.path ? (
                <Link
                  key={item.label}
                  to={item.path}
                  className="cursor-hover text-sm tracking-[0.25em] text-neutral-300 hover:text-white transition-colors duration-300 font-light"
                >
                  {item.label}
                </Link>
              ) : (
                <button
                  key={item.label}
                  onClick={() => scrollToSection(item.scroll)}
                  className="cursor-hover text-sm tracking-[0.25em] text-neutral-300 hover:text-white transition-colors duration-300 font-light bg-transparent"
                >
                  {item.label}
                </button>
              )
            )}

            {/* BOOK NOW */}
            <button
              onClick={openWhatsApp}
              className="cursor-hover ml-4 px-6 py-2.5 border border-[#d4af37]/40 text-[#d4af37] text-sm tracking-[0.2em] hover:bg-[#d4af37] hover:text-neutral-950 transition-all duration-500"
            >
              BOOK NOW
            </button>
          </div>

          {/* MOBILE MENU BUTTON */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle Menu"
            className="md:hidden cursor-hover flex flex-col justify-center items-center w-8 h-8 relative z-50"
          >
            <span
              className={`block w-7 h-[2px] bg-white transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-[6px]" : ""
                }`}
            />
            <span
              className={`block w-7 h-[2px] bg-white transition-all duration-300 ${menuOpen ? "opacity-0" : ""
                }`}
            />
            <span
              className={`block w-7 h-[2px] bg-white transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-[6px]" : ""
                }`}
            />
          </button>
        </div>
      </nav>

      {/* MOBILE MENU OVERLAY */}
      <div
        className={`fixed inset-0 bg-neutral-950 z-40 transition-all duration-700 md:hidden flex flex-col items-center justify-center ${menuOpen ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
      >
        {navItems.map((item, i) =>
          item.path ? (
            <Link
              key={item.label}
              to={item.path}
              onClick={() => setMenuOpen(false)}
              className="text-3xl tracking-[0.3em] text-white font-light mb-4"
              style={{
                animation: menuOpen
                  ? `fadeSlideUp 0.6s ease forwards ${i * 0.12}s`
                  : "none",
              }}
            >
              {item.label}
            </Link>
          ) : (
            <button
              key={item.label}
              onClick={() => scrollToSection(item.scroll)}
              className="text-3xl tracking-[0.3em] text-white font-light mb-4 bg-transparent"
              style={{
                animation: menuOpen
                  ? `fadeSlideUp 0.6s ease forwards ${i * 0.12}s`
                  : "none",
              }}
            >
              {item.label}
            </button>
          )
        )}

        {/* BOOK NOW (Mobile) */}
        <button
          onClick={() => scrollToSection("contact")}
          className="mt-4 px-10 py-3 border border-[#d4af37]/40 text-[#d4af37] text-lg tracking-[0.2em] hover:bg-[#d4af37] hover:text-neutral-950 transition-all duration-500"
        >
          BOOK NOW
        </button>
      </div>

      {/* ANIMATION */}
      <style>{`
        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
};

export default Navigation;
